import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class IntercomService {

  public unreadCount: number = 0;

  _unreadCountSubject: Subject<number> = new BehaviorSubject(0);
  onUnreadCountChange$: Observable<number> = this._unreadCountSubject.asObservable();

  _onHideSubject: Subject<any> = new BehaviorSubject(null);
  onHide$: Observable<any> = this._unreadCountSubject.asObservable();

  _onShowSubject: Subject<any> = new BehaviorSubject(null);
  onShow$: Observable<any> = this._unreadCountSubject.asObservable();

  constructor() {
    try {
      (window as any).Intercom('onUnreadCountChange', (unreadCount: number) => {
        this._unreadCountSubject.next(unreadCount);
        this.unreadCount = unreadCount;
      });

      (window as any).Intercom('onHide', () => {
        this._onHideSubject.next(true);
      });

      (window as any).Intercom('onShow', () => {
        this._onShowSubject.next(true);
      });

    } catch (e) {

    }
  }

  public boot(data: any): void {
    try {
      (window as any).Intercom('boot', data);
    } catch (e) {

    }
  }

  public update(data?: any): void {
    try {
      (window as any).Intercom('update', data);
    } catch (e) {

    }
  }

  public show(): void {
    try {
      (window as any).Intercom('show');
    } catch (e) {

    }
  }

  public shutdown(): void {
    try {
      (window as any).Intercom('shutdown');
    } catch (e) {

    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/intercom.service.ts